import React from 'react';
import { Button } from '@/components/ui/button';
import { Undo, Redo } from 'lucide-react';
import { useAnnotationUndoRedo } from '@/hooks/useAnnotationUndoRedo';
import { cn } from '@/lib/utils';

interface UndoRedoIndicatorProps {
  floorPlanId: string;
  className?: string;
}

export function UndoRedoIndicator({ floorPlanId, className }: UndoRedoIndicatorProps) {
  const { performUndo, performRedo, canUndo, canRedo, undoDescription, redoDescription } = useAnnotationUndoRedo(floorPlanId);
  
  // Don't show if neither action is available
  if (!canUndo && !canRedo) {
    return null;
  }
  
  return (
    <div className={cn("flex gap-1", className)}>
      <Button
        variant="ghost"
        size="sm"
        onClick={performUndo}
        disabled={!canUndo}
        title={undoDescription ? `Undo: ${undoDescription} (Ctrl+Z)` : 'Undo (Ctrl+Z)'}
        className="h-8 w-8 p-0"
      >
        <Undo className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={performRedo}
        disabled={!canRedo}
        title={redoDescription ? `Redo: ${redoDescription} (Ctrl+Shift+Z)` : 'Redo (Ctrl+Shift+Z)'}
        className="h-8 w-8 p-0"
      >
        <Redo className="h-4 w-4" />
      </Button>
    </div>
  );
}